import { render, staticRenderFns } from "./BrandResult.vue?vue&type=template&id=229d58c8&scoped=true"
import script from "./BrandResult.vue?vue&type=script&lang=js"
export * from "./BrandResult.vue?vue&type=script&lang=js"
import style0 from "./BrandResult.vue?vue&type=style&index=0&id=229d58c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229d58c8",
  null
  
)

export default component.exports